import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';

const SlopeHelpModal = ({ shModalIsOpen, closeSHModal }) => {
    return (
        <Modal
            show={shModalIsOpen}
            onHide={closeSHModal}
            backdrop='static'
            size='lg'
            centered
            scrollable
            contentClassName='background'
        >
            <Modal.Header>
                <Modal.Title>Roof Slope</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>For us to create the most accurate picture of where the panels will be installed, we need to know the slope of the roof or surface that they will be mounted on.</p>
                <p>If you have access to the roof you can use a simple app on your phone to measure the slope, but please be safe. Don't put yourself in any danger.</p>
                <p>On iPhones you can use the Measure app, on Android there are many to choose including Bubble Level:</p>
                <div className='app-icon-image-box'>
                    <Image src='https://res.cloudinary.com/dujftalas/image/upload/c_scale,r_0,w_108/v1677622744/measure_app_apple_v53yvw.png' />
                    <Image src='https://res.cloudinary.com/dujftalas/image/upload/c_scale,w_108/v1678830292/Screenshot_2023-03-14_at_21.43.42_cbyvp4.png' />
                </div>
                <p>Please don't put yourself in any danger trying to measure the roof slope! Most domestic roofs have a slope of around 35°, so that is fine for our simple calculation unless your roof is very steep, or very flat. For reference, panels flat on a roof would have a slope of 0° and those mounted flat on a wall would have a slope of 90°.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button className='modal-button' onClick={closeSHModal}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SlopeHelpModal;
